var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-add-circle-outline",
    "data-name": "Icon ionic-md-add-circle-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.755,
    height: 38.755,
    viewBox: "0 0 38.755 38.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38771",
    "data-name": "Path 38771",
    d: "M30.413,22.4H22.4v8.012H18.488V22.4H10.477V18.488h8.012V10.477H22.4v8.012h8.012Z",
    transform: "translate(-1.067 -1.067)",
    fill: "#bdc4cb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38772",
    "data-name": "Path 38772",
    d: "M22.752,7.288a15.458,15.458,0,1,1-10.937,4.528A15.4,15.4,0,0,1,22.752,7.288m0-3.913A19.377,19.377,0,1,0,42.13,22.752,19.374,19.374,0,0,0,22.752,3.375Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#bdc4cb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.2606f366f69d00ed445b756622cbf364.svg";
export { ForwardRef as ReactComponent };